import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ICell } from '../../_shared/models/table/cell.model';
import { IListTables } from '../../_shared/models/table/list-tables.model';
import { IRow } from '../../_shared/models/table/row.model';

import { HeadingComponent } from '../../heading/heading.component';

@Component({
    selector: 'sirius-table-list',
    templateUrl: './table-list.component.html',
    styleUrls: ['../table.component.scss', './table-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HeadingComponent]
})
export class TableListComponent implements OnInit {
    @Input() rows?: IRow[];

    mobileLayout: IListTables = {
        title: '',
        tables: [],
    };

    ngOnInit(): void {
        if (!this.rows) return;

        const firstRow = this.rows[0];
        this.mobileLayout.title = firstRow?.cells[0].valueHtml;

        this.rows.forEach((x: IRow, i: number) => {
            if (i === 0) return;

            const subtitle = x.cells[0].valueHtml;
            const firstCellsRemoved = x.cells.filter((_, j: number) => j > 0);

            const newLayout = firstCellsRemoved.map((y: ICell, j: number) => {
                return {
                    header: firstRow?.cells[j + 1].valueHtml,
                    data: y.valueHtml,
                };
            });

            this.mobileLayout.tables.push({
                //TODO: Rename to subtitle
                subTitle: subtitle,
                rows: newLayout,
            });
        });
    }
}
